<!--
 Created by Daniil Vat. on 28/3/2021
 Copyright © 2021 Curriculum Ltd. All rights reserved.
-->
<div class="chart-container" *ngIf="chartData">
  <canvas baseChart [data]="chartData" [labels]="labels" [chartType]="type" [options]="options" [colors]="colors"
    [legend]="false" [plugins]="plugins">
  </canvas>
</div>
